import { atomHelpers } from '@approvalmax/utils';
import { atom } from 'jotai';

const fileUploadsTimestampsAtom = atomHelpers.createAtomWithStorage<string[]>('fileDateUploads', []);

export const fileUploadsTimestampsState = atom(
    (get) => get(fileUploadsTimestampsAtom),
    (_get, set, action: 'add') => {
        if (action === 'add') {
            set(fileUploadsTimestampsAtom, (prev) => [...prev, new Date().toISOString()]);
        }
    }
);
